import { SvgIcon, SvgIconProps } from '@mui/material'

const SoilIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 19 19" {...props}>
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        fill="#FFEF98"
      />
      <rect
        x=".989"
        y=".793"
        width="16.972"
        height="16.972"
        rx="8.486"
        stroke="#282828"
        strokeWidth="1.5"
      />
      <path
        d="M6.151 11.82c-.142 0-.286-.004-.432-.013a13.26 13.26 0 0 1-.426-.035 10.687 10.687 0 0 1-.405-.061 5.351 5.351 0 0 1-.357-.076v-.94c.146.013.309.025.487.034a21.03 21.03 0 0 0 1.072.027c.16 0 .295-.011.405-.034a.54.54 0 0 0 .26-.13.368.368 0 0 0 .09-.261v-.13c0-.125-.041-.218-.124-.282a.46.46 0 0 0-.302-.097h-.398c-.513 0-.902-.112-1.167-.336-.266-.224-.399-.602-.399-1.133v-.24c0-.5.147-.868.44-1.106.293-.242.714-.364 1.263-.364.202 0 .396.012.584.035.188.018.366.04.535.068.17.028.319.058.447.09v.933c-.21-.013-.447-.027-.708-.04-.26-.015-.498-.021-.714-.021-.141 0-.267.013-.377.04a.444.444 0 0 0-.254.138c-.06.064-.09.16-.09.289v.096c0 .146.042.254.124.322.087.069.217.103.391.103h.474c.316 0 .577.06.783.179.206.114.36.275.46.48.105.202.158.43.158.687v.254c0 .421-.076.742-.227.962-.146.22-.357.368-.631.446-.27.078-.59.116-.962.116Zm2.71-.04.598-5.095h1.126l1.106 3.728 1.098-3.728h1.113l.604 5.094h-1.14l-.419-3.495.179.007-.893 3.488h-1.112l-.9-3.488.193-.007-.405 3.495H8.861Z"
        fill="#002031"
      />
    </SvgIcon>
  )
}

export default SoilIcon
